import { Form } from "react-bootstrap";

interface ToggleSwitchProps {
  id: string;
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
}

const ToggleSwitch = ({ id, label, value, onChange }: ToggleSwitchProps) => {
  return (
    <div className="d-flex flex-row align-content-center">
      <Form.Check
        id={id}
        className="align-self-center"
        type="switch"
        checked={value}
        onChange={(e) => onChange(e.target.checked)}
      />
      <label htmlFor={id} className="me-1 text-black">
        {label}
      </label>
    </div>
  );
};

export default ToggleSwitch;
